export default __webpack_public_path__ + "static/media/folder-icon.40fa971e.svg";